import logoMarkLight from "@/assets/flowtokos-mark-new.png";
import logoMarkDark from "@/assets/flowtokos-mark-new.png";
import logoFullLight from "@/assets/flowtokos-logo-light.png";
import logoFullDark from "@/assets/flowtokos-logo-dark.png";

interface FlowTokLogoProps {
  size?: number;
  /** light = for light backgrounds (black wordmark). dark = for dark backgrounds (white wordmark). */
  variant?: "light" | "dark";
  showWordmark?: boolean;
  className?: string;
  /** Render full lockup PNG (mark + wordmark + tagline) instead of mark + text */
  useFull?: boolean;
}

/**
 * Official FlowTokOS logo. DO NOT modify proportions or colors.
 * Uses the locked brand assets from src/assets/flowtokos-*.png.
 */
export function FlowTokLogo({
  size = 36,
  variant = "light",
  showWordmark = true,
  className = "",
  useFull = false,
}: FlowTokLogoProps) {
  const markSrc = variant === "dark" ? logoMarkDark : logoMarkLight;
  const fullSrc = variant === "dark" ? logoFullDark : logoFullLight;

  if (useFull) {
    return (
      <div className={`flex items-center ${className}`}>
        <img
          src={fullSrc}
          alt="FlowTokOS — The Operating System for Social Commerce"
          style={{ height: size, width: "auto" }}
        />
      </div>
    );
  }

  // Mark-only mode (icon + optional wordmark text rendered alongside)
  if (!showWordmark) {
    return (
      <div className={`flex items-center ${className}`}>
        <img
          src={markSrc}
          alt="FlowTokOS"
          style={{ width: size, height: size, objectFit: "contain", flexShrink: 0 }}
        />
      </div>
    );
  }

  // Mark + wordmark composed inline (used in dense nav contexts where the full PNG would be too tall).
  const wordmarkColor = variant === "dark" ? "#F5F7FA" : "#050505";
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={markSrc}
        alt="FlowTokOS"
        style={{ width: size, height: size, objectFit: "contain", flexShrink: 0 }}
      />
      <span
        className="font-semibold"
        style={{
          fontFamily:
            "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif",
          fontSize: size * 0.46,
          lineHeight: 1,
          letterSpacing: "-0.022em",
          color: wordmarkColor,
        }}
      >
        FlowTok
        <span
          style={{
            background:
              "linear-gradient(90deg, #5B5CFF 0%, #A855F7 50%, #22D3EE 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            marginLeft: 4,
          }}
        >
          OS
        </span>
      </span>
    </div>
  );
}
